import React from 'react'

function RedX ({ style }) {
  const FILL = '#D00000'
  const svgStyle = { fill: FILL, ...style }
  return (
    <svg
      preserveAspectRatio='xMidYMid meet'
      style={svgStyle}
      viewBox='0 0 100 100'
    >
      <title>ERROR</title>
      <description>red X error icon</description>
      <path d='M82.8,95.9L50,63.1L17.2,95.9c-3.6,3.6-9.5,3.6-13.1,0c0,0,0,0,0,0l0,0c-3.6-3.6-3.6-9.5,0-13.1c0,0,0,0,0,0
        L36.9,50L4.1,17.2c-3.6-3.6-3.6-9.5,0-13.1c0,0,0,0,0,0l0,0c3.6-3.6,9.5-3.6,13.1,0c0,0,0,0,0,0L50,36.9L82.8,4.1
        c3.6-3.6,9.5-3.6,13.1,0c0,0,0,0,0,0l0,0c3.6,3.6,3.6,9.5,0,13.1c0,0,0,0,0,0L63.1,50l32.8,32.8c3.6,3.6,3.6,9.5,0,13.1c0,0,0,0,0,0
        l0,0C92.3,99.5,86.4,99.5,82.8,95.9C82.8,95.9,82.8,95.9,82.8,95.9z'
      />
    </svg>
  )
}

export default RedX
